<template>
  <h1>{{ title }}</h1>
</template>

<script>
  import Vue from 'vue';

  export default Vue.component('BicTitle', {
    props: {
      mode: String,
      term: String,
    },
    computed: {
      title: function() {
        return this.getTitle(this.mode, this.term);
      },
    },
    methods: {
      getTitle: function(mode, term) {
          let title;
          switch(mode) {
            case 'search':
              if (term) {
                title = `Search Results for '${term}'`;
              } else {
                title = 'Search for a code';
              }
              break;
            case 'browse':
              title = 'Browse for a code';
              break;
            case 'select':
              title = 'Selected results';
              break;
            default:
              title = 'Find your Business Industry Classification Code';
          }
          return title;
      },
    },
  });
</script>